<div class="cpcontent">
  <h2>Simple GPS get location call</h2>
  <span>Click the button to get your coordinates.</span>

  <button (click)="getLocation()" style="margin-left:10px">Try It</button>

  <p #demo></p>
  <hr>
  You can test this by disabling the gps of your laptop.<br>
  In Chrome goto Settings => Privacy and security => Site Settings<br>
  The select "Localhost:4200" or the one that you are using and block "Location"
  <hr>
  Further Note: The gps functions are wrapped into its own class GPS
  <hr>
</div> 